import React, {useEffect, useCallback, useState} from 'react';
import {UniverseCarousel} from './UniverseCarousel';
import {HomepageIntro} from './HomepageIntro';
import {HomepageMainIntroProps, IndustryProps, UniverseProps} from './HomepageHeader.types';
import {HomepageSmallHeader} from './HomepageSmallHeader';
import {useBreakpointDown} from 'epic-ue-theme';
import root from 'window-or-global';
import {HomepageFakeCards} from './HomepageHeaderFakeCards';

export interface HomepageHeaderProps {
    intro: HomepageMainIntroProps;
    universe: UniverseProps;
}

export const HomepageHeader = ({universe, intro}: HomepageHeaderProps): JSX.Element => {
    const vh = Math.max(root.innerHeight || 0);
    const [lockUniverse, setLockUniverse] = useState(false);
    const [universeOffset, setUniverseOffset] = useState(vh + 500);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [introRan, setIntroRan] = useState(false);
    const [position, setPosition] = useState(root.pageYOffset || root.scrollY);

    const universeId = 'ue-universe';

    const lockScroll = (canScroll) => {
        setLockUniverse(canScroll);
    };
    const introDone = (done) => {
        setIntroRan(done);
    };

    const handleScroll = useCallback(() => {
        const scrollY = root.pageYOffset || root.scrollY;
        setPosition(scrollY);
        if (lockUniverse) {
            root.scrollTo(0, universeOffset, 'smooth');
        }
    }, [lockUniverse]);

    useEffect(() => {
        if (hasLoaded) {
            const el = root.document.getElementById(universeId);
            if (el) {
                const offset = el.getBoundingClientRect().top + root.scrollY;
                setUniverseOffset(offset);
            }
        }
        setHasLoaded(true);
        root.document.addEventListener('scroll', handleScroll);
        root.document.addEventListener('touchmove', handleScroll);
        return () => {
            root.document.removeEventListener('scroll', handleScroll);
            root.document.removeEventListener('touchmove', handleScroll);
        };
    }, [handleScroll, setHasLoaded]);

    const downSm = useBreakpointDown('sm');
    let industries: IndustryProps[] = [];
    if (universe) {
        industries = universe.industries || [];
    }

    if (downSm) {
        return <HomepageSmallHeader introData={intro} industries={industries} />;
    }

    let universeElements: JSX.Element = <div key="universeElements" />;
    if (!downSm) {
        if (introRan) {
            universeElements = <HomepageFakeCards position={position} />;
        }
    }

    return (
        <>
            <HomepageIntro introData={intro} />
            <UniverseCarousel
                id={universeId}
                industries={industries}
                introDoneCallback={introDone}
                lockScroll={lockScroll}
            />
            {universeElements}
        </>
    );
};
